
import React from 'react';
import './EscalationTableSection.css'; 

const EscalationTableSection = () => {
  return (
    <section className="_eTSect_t1A_"> 
      <div className="_eTCont_u2B_"> 
        <h2 className="_eTitle_v3C_"> 
          Escalation Matrix
        </h2>
        <div className="_tContainer_w4D_"> 
          <table className="_eTable_x5E_"> 
            <thead>
              <tr>
                <th>Level</th>
                <th>Handled By</th>
                <th>Typical Issues</th>
                <th>Target Response</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Support Agent/Volunteer</td>
                <td>Order, payment, routine queries</td>
                <td>&lt;2 hr</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Seller/Temple Manager</td>
                <td>Payouts, conduct, policy disputes</td>
                <td>&lt;8 hr</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Platform Admin/Escalation Manager</td>
                <td>Multi-party, fraud, compliance</td>
                <td>&lt;24 hr</td>
              </tr>
              <tr>
                <td>4</td>
                <td>Compliance/Legal</td>
                <td>Legal, ethics, severe abuse</td>
                <td>&lt;48 hr</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default EscalationTableSection;